import Component from "vue-class-component";
import Vue from "vue";
import { Episode, Movie } from "@/services/apiService/api.types";
import { Getter } from "vuex-class";
import { OverlayGetter } from "@/components/overlay/types";
import { Namespace } from "@/store/types";
import dayjs from "dayjs";

@Component
export class VodMetaDataHandler extends Vue {
  @Getter(OverlayGetter.GetActiveVodItem, {
    namespace: Namespace.Overlay
  })
  getActiveVodItem!: Movie | Episode | null;

  @Getter(OverlayGetter.GetActiveVodItemDuration, {
    namespace: Namespace.Overlay
  })
  getActiveVodItemDuration!: number | null;

  @Getter(OverlayGetter.GetActiveVodItemProgressDuration, {
    namespace: Namespace.Overlay
  })
  getActiveVodItemProgressDuration!: number | null;

  get vodTitle(): string {
    return this.getActiveVodItem ? this.getActiveVodItem.name : "No Info";
  }

  get vodDescription(): string {
    return this.getActiveVodItem && this.getActiveVodItem.description
      ? this.getActiveVodItem.description
      : "No description available";
  }

  get formattedProgress(): string {
    if (this.getActiveVodItemProgressDuration !== null) {
      return dayjs
        .duration(this.getActiveVodItemProgressDuration, "s")
        .format("HH:mm:ss");
    }

    return "--/--";
  }

  get formattedDuration(): string {
    if (this.getActiveVodItemDuration !== null) {
      return dayjs
        .duration(this.getActiveVodItemDuration, "s")
        .format("HH:mm:ss");
    }

    return "--/--";
  }

  get getPlaybackPercentage(): number {
    if (
      this.getActiveVodItemDuration !== null &&
      this.getActiveVodItemProgressDuration !== null
    )
      return Math.max(
        0,
        Math.min(
          100,
          100 *
            (this.getActiveVodItemProgressDuration /
              this.getActiveVodItemDuration)
        )
      );

    return 0;
  }

  get vodThumbnail(): string {
    return this.getActiveVodItem && this.getActiveVodItem.media
      ? this.getActiveVodItem.media.url
      : this.imgPlaceholder;
  }

  get imgPlaceholder(): string {
    return require("/src/assets/images/square-image-placeholder.jpg");
  }
}
